<template>
  <header
    class="header-mobile"
    :class="{ open }"
  >
    <button
      aria-label="Open Sidebar"
      class="header-mobile-collapse"
      @click="toggleMenu"
    >
      <AppIcon
        name="menu"
        size="small"
      />
    </button>
    <div class="header-mobile-logo mx-auto absolute left-[50%] -translate-x-2/4">
      <TagLink
        :tag="commonLink.home.tag"
        :attr-tag="commonLink.home.attrTag"
      >
        <img
          src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
        >
      </TagLink>
    </div>

    <div class="flex items-center space-s-6">
      <button
        class="text-gray-medium focus:text-blue-primary"
        @click="openSearchBox"
      >
        <AppIcon name="magnify" />
      </button>
      <client-only>
        <TagLink
          v-if="!auth.loggedIn"
          :tag="commonLink.login.tag"
          :attr-tag="commonLink.login.attrTag"
          class="profileSignUp"
        >
          <AppIcon
            name="account"
            color="text-gray-medium"
          />
        </TagLink>
        <DropdownButton
          v-if="auth.loggedIn"
          offset-class="left-0"
          :button="{
            text: '',
            mode: 'icon',
            size: 'xs',
            color: 'gray'
          }"
          :icon="{
            name: 'account',
            color: 'text-gray-medium',
            size: 'medium'
          }"
          list-name="avatar"
        />
      </client-only>
    </div>
    <!-- Sidebar -->
    <nav class="header-mobile-menu">
      <div class="header-mobile-menu__header" />
      <button
        aria-label="Close Sidebar"
        class="header-mobile-menu__close"
        @click="toggleMenu"
      >
        <AppIcon name="close" />
      </button>
      <ul class="header-mobile-menu__list">
        <template v-for="(item, index) in linkSidebarMobile">
          <li
            :key="`menu_items-${index}`"
            :class="{'py-4 border-b border-solid border-gray-light': item.divider }"
          >
            <TagLink
              :tag="item.tag"
              :attr-tag="item.attrTag"
              @click="toggleMenu"
            >
              <AppIcon
                :name="item.icon"
                size="medium"
              />
              <span>{{ item.text }}</span>
            </TagLink>
          </li>
        </template>
      </ul>
      <div class="header-mobile-menu__call">
        <div class="header-mobile-menu__call__label">
          <span>
            {{ $t("menu.backup") }}
          </span>
          <AppIcon name="phone" />
        </div>
        <div class="header-mobile-menu__call__number CallButton">
          <a
            v-if="ostadbankSupportPhone"
            :href="'tel:' + ostadbankSupportPhone"
          >{{ ostadbankSupportPhone }}</a>
        </div>
      </div>
    </nav>
    <div
      class="header-mobile-overly"
      @click="toggleMenu"
    />
  </header>
</template>

<script>

import DropdownButton from '@library/element/dropdown/dropdown-button'

export default {
  name: 'HeaderTopMobile',
  components: { DropdownButton },
  inject: ['allProps'],
  data () {
    return {
      open: false,
      isOpenSearch: false
    }
  },
  computed: {
    linkSidebarMobile () {
      return this.allProps.data.linksHeaderTop.linkSidebarMobile
    },
    ostadbankSupportPhone () {
      return this.allProps.data.ostadbankSupportPhone
    },
    commonLink () {
      return {
        home: this.allProps.data.linksHeaderTop.home,
        login: this.allProps.data.linksHeaderTop.login
      }
    },
    auth () {
      return this.allProps.data.auth
    }
  },
  methods: {
    openSearchBox () {
      this.$emit('emitOpenSearchBox')
    },
    toggleMenu () {
      const body = document.querySelector('body')
      if (this.open) {
        body.classList.remove('overflow-hidden')
        body.classList.remove('lg:overflow-auto')
        body.classList.remove('pr-1')
        body.classList.remove('lg:pr-0')
      } else {
        body.classList.add('overflow-hidden')
        body.classList.add('lg:overflow-auto')
        body.classList.add('pr-1')
        body.classList.add('lg:pr-0')
      }
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss">
.header-mobile {
  @apply h-14 flex justify-between place-items-center w-full px-4;
  &-collapse {
    @apply text-gray-medium focus:outline-none focus:text-blue-primary;
    svg {
      @apply text-4xl;
    }
  }

  &-menu {
    @apply fixed flex flex-col  min-h-screen top-0 bottom-0 -right-64 transition-all bg-white w-64  z-20;
    &__header {
      @apply h-6 bg-yellow-primary;
    }

    &__close {
      @apply px-4 focus:outline-none focus:text-blue-primary  text-gray-medium text-right mt-2;
      svg {
        @apply text-2xl;
      }
    }

    &__list {
      @apply px-4 mt-16;
      li {
        @apply mb-6;
        a {
          @apply flex items-center text-gray-medium hover:text-blue-hover;
          span {
            @apply text__sub--1 pr-6;
          }
        }
      }
    }

    &__call {
      @apply mt-auto mb-14 mx-auto text-center;
      &__label {
        @apply mb-2.5 flex items-center justify-center;
        span {
          @apply text-gray-medium font-normal  inline-block ml-3  lg:text-lg;
        }

        svg {
          @apply text-blue-primary text-base font-normal  lg:text-lg;
        }
      }

      &__number {
        @apply text-gray-main font-normal;
      }
    }
  }

  &-overly {
    @apply fixed inset-0 min-h-screen bg-gray-light z-10 hidden;
  }

  &.open {
    .header-mobile {
      &-menu {
        @apply right-0;
      }

      &-overly {
        @apply block;
      }
    }
  }
}
</style>
